<template>
  <el-dialog :title="titleList[popType]" :visible.sync="formVisible" :close-on-click-modal="false" width="1000px">
    <el-form ref="dataForm" label-position="right" :rules="formRules" :model="form" size="small" label-width="130px">
      <Title v-if="[2].includes(popType)">用户基础信息</Title>
      <el-form-item :label="[3,4].includes(popType)?'转入业务员：':'业务员：'" prop="inviteUserId" v-if="[0,1,3,4].includes(popType)" class="width100" :rules="[{required:true,message: '请选择业务员',trigger: 'change'}]">
        <el-select v-model="form.inviteUserId" placeholder="请选择业务员" filterable clearable :filter-method="customerFilter" @blur="getBusinessList()">
          <!-- <el-option :label="`${item.name} ${item.pho}`" :value="item.id" v-for="item in businessList" :key="item.id"></el-option> -->
          <el-option :label="`${item.name}（${item.levelName}）${item.pho}`" :value="item.id" v-for="item in businessList" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="客户姓名：" prop="customerName" v-if="[0,1,2].includes(popType)" :class="{'width100':[0,1].includes(popType)}" :rules="[{required:true,message: '请输入姓名',trigger: 'blur'}]">
        <el-input v-model="form.customerName" placeholder="请输入姓名" />
      </el-form-item>
      <el-form-item label="手机号：" prop="customerPhone" v-if="[0,1,2].includes(popType)" :class="{'width100':[0,1].includes(popType)}" :rules="[{required:true,message: '请输入手机号',trigger: 'blur'},{ pattern: /^[0-9]*$/, message: '请输入正确的手机号'},{ pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur'  }]">
        <el-input v-model="form.customerPhone" placeholder="请输入手机号" maxlength="11" />
      </el-form-item>
      <!-- <el-form-item label="用友编码：" prop="customerAddDTO.code" v-if="popType==2">
        <el-input v-model="form.customerAddDTO.code" placeholder="根据用友返回" disabled />
      </el-form-item> -->
      <!-- <el-form-item label="升级身份：" prop="customerAddDTO.clevel" v-if="[2].includes(popType)"
        :rules="[{required:true,message: '请选择身份',trigger: 'change'}]">
        <el-select v-model="form.customerAddDTO.clevel" placeholder="请选择身份" @change="standingChange">
          <el-option :label="item.name" :value="item.level" v-for="item in standingList" :key="item.id"></el-option>
        </el-select>
      </el-form-item> -->
      <!-- <el-form-item label="折扣组:" prop="customerAddDTO.profitRatioId" v-if="[0,7].includes(popType)"
        :class="{'width100':popType==7}">
        <el-select v-model="form.customerAddDTO.profitRatioId" placeholder="请选择">
          <el-option :label="item.title" :value="item.id" v-for="item in discountList" :key="item.id"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="门店类型：" prop="storeType" v-if="[0,1,2].includes(popType)" :rules="[{required: true,message: '请选择门店类型',trigger: 'change'}]" :class="{'width100':[0,1].includes(popType)}">
        <el-select v-model="form.storeType" placeholder="请选择门店类型">
          <el-option :label="item" :value="item" v-for="(item,index) in options.storeTypeList" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="企业名称：" prop="companyName" v-if="[0,1,2].includes(popType)" :class="{'width100':[0,1].includes(popType)}" :rules="[{required:true,message: '请输入企业名称',trigger: 'blur'}]">
        <el-input v-model="form.companyName" placeholder="请输入企业名称" />
      </el-form-item>
      <el-form-item label="日均门诊量：" prop="dailyOutpatientVisits" v-if="[0,1,2].includes(popType)" :rules="[{required: true,message: '请选择日均门诊量',trigger: 'change'}]" :class="{'width100':[0,1].includes(popType)}">
        <el-select v-model="form.dailyOutpatientVisits" placeholder="请选择日均门诊量">
          <el-option :label="item" :value="item" v-for="(item,index) in options.frequencyList" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="员工数量：" prop="staffNum" v-if="[0,1,2].includes(popType)" :rules="[{required: true,message: '请选择员工数量',trigger: 'change'}]" :class="{'width100':[0,1].includes(popType)}">
        <el-select v-model="form.staffNum" placeholder="请选择员工数量">
          <el-option :label="item" :value="item" v-for="(item,index) in options.staffNum" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="正在开展项目：" prop="projectId" v-if="[0,1,2].includes(popType)" :rules="[{required: true,message: '请选择正在开展项目',trigger: 'change'}]" :class="{'width100':[0,1].includes(popType)}">
        <el-select v-model="form.projectId" multiple placeholder="请选择正在开展项目">
          <el-option :label="item" :value="item" v-for="(item,index) in options.projectList" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属区域：" prop="addr" v-if="[0,1,2].includes(popType)" :class="{'width100':[0,1].includes(popType)}" :rules="[{required: true,message: '请选择省市区',trigger: 'change'}]">
        <el-cascader v-model="form.addr" :props="cascaderProps" collapse-tags :options="addressList" clearable placeholder="请选择省市区" @change="regionChange"></el-cascader>
      </el-form-item>
      <!-- <el-form-item label="详细地址：" prop="addrDetail">
        <el-input v-model="form.customerAddDTO.addrDetail" placeholder="请输入详细地址" />
      </el-form-item> -->
      <el-form-item label="微信号：" prop="wechatNumber" v-if="[0,1].includes(popType)" :class="{'width100':[0,1].includes(popType)}">
        <el-input v-model="form.wechatNumber" placeholder="请输入客户微信号" />
      </el-form-item>
      <el-form-item label="客户标签：" prop="customerTagId" class="width100" v-if="[0,1].includes(popType)">
        <el-cascader v-model="form.customerTagId" :options="labelList" :props="labelProps" :show-all-levels="false" placeholder="请选择技术标签">
        </el-cascader>
      </el-form-item>
      <el-form-item label="意向度：" prop="intentionality" v-if="[0,1].includes(popType)" :class="{'width100':[0,1].includes(popType)}">
        <el-select v-model="form.intentionality" placeholder="请选择客户意向度">
          <el-option label="高" :value="1"></el-option>
          <el-option label="中" :value="2"></el-option>
          <el-option label="低" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注：" prop="remark" class="width100" v-if="[0,1].includes(popType)" :class="{'width100':[0,1].includes(popType)}">
        <el-input v-model="form.remark" placeholder="请输入备注" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import clientListApi from '@/api/client/clientList'
import userApi from '@/api/user'

function initFormBean() {
  const formBean = {
    inviteUserId: null,
    customerName: null,
    customerPhone: null,
    storeType: null,
    companyName: null,
    staffNum: null,
    projectId: null,
    addr: null,
    dailyOutpatientVisits: null,
    wechatNumber: null,
    intentionality: null,
    remark: null,
    customerTagId: null
  }
  return formBean
}

export default {
  //popType 0:新增 1:编辑 2:身份升级 3:转给其他人
  props: {
    standingList: Array,
    discountList: Array,
    configList: Array,
    labelList: Array,
    addressList: Array,
    // businessList: Array,
    popType: Number
  },
  data() {
    return {
      titleList: ['添加线索', '编辑线索', '身份升级', '转给其他人', '转给其他人'],
      isLoading: false,
      form: initFormBean(),
      formVisible: false,
      options: {
        projectList: [], //   正在开展项目
        storeTypeList: [], //门店类型
        frequencyList: [], //日均门诊人次
        staffNum: [] //员工数量
      },
      businessList: null,
      cascaderProps: {
        label: 'regionName',
        value: 'id',
        children: 'child',
        // multiple: true
      },
      labelProps: {
        label: 'name',
        value: 'id',
        children: 'children',
        multiple: true
      },
      // companyOption: [],
      selectItems: []
    }
  },
  created() {

  },
  methods: {
    customerFilter(e) {
      this.getBusinessList(e)
    },
    // 获取业务员列表
    getBusinessList(name) {
      let obj = { customerTypes: 2, isGetAllParent: true, isDeparted: 0, pageNo: 1, pageSize: 100, name }
      clientListApi.getListPageForMini(obj).then(({
        data
      }) => {
        this.businessList = data.list
        
      })
    },
    resetForm() {
      this.form = initFormBean()
    },
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
        this.configList.forEach(i => {
          if (i.code == "carryProjects") this.options.projectList = i.content.split(',')
          if (i.code == "shopType") this.options.storeTypeList = i.content.split(',')
          if (i.code == "dayAVGOutpatients") this.options.frequencyList = i.content.split(',')
          if (i.code == "employeeNums") this.options.staffNum = i.content.split(',')
          // console.log('staffNum: ', this.options.staffNum);
        })
      })
    },
    handleUpdate({
      row,
      command
    }) {
      // console.log('popType: ',this.popType);
      console.log('row: ', row, this.labelList, command);
      this.resetForm()
      if (command) {
        if (command != 4) {
          this.form = {
            ...row
          }
          if (row.projectId) {
            this.form.projectId = this.form.projectId ? this.form.projectId.split(',') : ''
          }
          this.form.intentionality = this.form.intentionality ? this.form.intentionality * 1 : null
          this.form.addr = [row.provinceId, row.cityId, row.regionId]
          if (row.customerTagList && row.customerTagList.length) {
            this.form.customerTagId = row.customerTagList.map(item => {
              let arr = []
              this.labelList.map(i => {
                // console.log('i.children.findIndex(i.id==item.id): ',i.children.findIndex(it=>it.id==item.id));
                if (i.children.findIndex(it => it.id == item.id) != -1) { arr = [i.id, item.id] }
              })
              return arr
            })
          }

        } else {
          this.selectItems = row
        }
        if ([3].includes(command)) {
          this.form.inviteUserId = null
        }
      }
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
        this.getBusinessList()
        this.configList.forEach(i => {
          if (i.code == "carryProjects") this.options.projectList = i.content.split(',')
          if (i.code == "shopType") this.options.storeTypeList = i.content.split(',')
          if (i.code == "dayAVGOutpatients") this.options.frequencyList = i.content.split(',')
          if (i.code == "employeeNums") this.options.staffNum = i.content.split(',')
          // console.log('staffNum: ', this.options.staffNum);
        })
      })
    },
    doCreate() {
      // console.log('-----12----',this.payVoucher);
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.isLoading = true
          let params = {}
          if (this.popType != 4) {
            params = {
              ...this.form,
            }
            params.provinceId = this.form.addr[0]
            params.cityId = this.form.addr[1]
            params.regionId = this.form.addr[2]
            if (this.form.customerTagId && this.form.customerTagId.length) {
              params.customerTagId = this.form.customerTagId.map(i => (i[1]))
            }
            delete params.addr
            console.log('this.form: ', params);
            if ([0, 1, 2].includes(this.popType)) {
              params.projectId = params.projectId ? params.projectId.toString() : ''
            }
          }
          // return
          if (!this.popType) {
            userApi.create(params).then((data) => {
              // this.technicalLine = ''
              // this.customerLine = ''
              this.postCallback(data)
            }).catch(res => {
              this.isLoading = false
            })
          }
          if (this.popType == 1) {
            userApi.update(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isLoading = false
            })
          }
          if ([3, 4].includes(this.popType)) {
            let query = {
              inviteUserId: this.form.inviteUserId
            }
            if (this.popType == 3) {
              query.id = [this.form.id]
            } else {
              query.id = this.selectItems.map(i => (i.id))
              // console.log('this.selectItems: ',this.selectItems);
            }
            console.log('query: ', query);
            // return
            userApi.transferTo(query).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isLoading = false
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    postCallback(data) {
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
      this.isLoading = false
    },
    standingChange(e) {
      //   this.form.customerAddDTO.profitRatioId = this.standingList.find(i => i.level == e).defaultProfitRatioId
      //   console.log('e: ', e);
    },
    // 选择区域
    regionChange(e) {
      console.log('e: ', e);
      // if (!e) return
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-upload--picture-card {
  width: 54px;
  height: 54px;
  line-height: 62px;
}

::v-deep .el-upload-list__item {
  width: 54px;
  height: 54px;
}

::v-deep .el-select {
  width: 100%;
}

::v-deep .el-cascader {
  width: 100%;
}

::v-deep .el-dialog {
  // max-height: 88vh;
  margin-top: 6vh !important;
}

::v-deep .el-form {
  // max-height: 64vh !important;
  // overflow-y: auto;
}

.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}

.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}

.el-form-item--small.el-form-item.width100 {
  width: 97%;
}

::v-deep .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 54px;
  height: 54px;
  line-height: 54px;
  text-align: center;
}

.avatar {
  width: 54px;
  height: 54px;
  display: block;
}

.card-uploader img {
  height: 132px;
  width: 194px;
  margin-right: 56px;
}
</style>
